export class AreaCodes {
  public static get codes(): any { return {
 "54": {
 "11": {
    "detail": "Ciudad Autónoma de Buenos Aires/\nProvincia de Buenos Aires (dentro del área metropolitana)"
 },
 "220": {
    "detail": "Buenos Aires"
 },
 "221": {
    "detail": "Buenos Aires"
 },
 "223": {
    "detail": "Buenos Aires"
 },
 "230": {
    "detail": "Buenos Aires"
 },
 "236": {
    "detail": "Buenos Aires"
 },
 "237": {
    "detail": "Buenos Aires"
 },
 "249": {
    "detail": "Buenos Aires"
 },
 "260": {
    "detail": "Mendoza"
 },
 "261": {
    "detail": "Mendoza"
 },
 "263": {
    "detail": "Mendoza"
 },
 "264": {
    "detail": "San Juan"
 },
 "266": {
    "detail": "San Luis"
 },
 "280": {
    "detail": "Chubut"
 },
 "291": {
    "detail": "Buenos Aires"
 },
 "294": {
    "detail": "Río Negro\nNeuquén \nChubut"
 },
 "297": {
    "detail": "Chubut \nSanta Cruz"
 },
 "298": {
    "detail": "Río Negro"
 },
 "299": {
    "detail": "Neuquén \nRío Negro\nLa Pampa"
 },
 "336": {
    "detail": "Buenos Aires"
 },
 "341": {
    "detail": "Santa Fe"
 },
 "342": {
    "detail": "Santa Fe"
 },
 "343": {
    "detail": "Entre Ríos"
 },
 "345": {
    "detail": "Entre Ríos"
 },
 "348": {
    "detail": "Buenos Aires"
 },
 "351": {
    "detail": "Córdoba"
 },
 "353": {
    "detail": "Córdoba"
 },
 "358": {
    "detail": "Córdoba"
 },
 "362": {
    "detail": "Chaco"
 },
 "364": {
    "detail": "Chaco"
 },
 "370": {
    "detail": "Formosa"
 },
 "376": {
    "detail": "Misiones"
 },
 "379": {
    "detail": "Corrientes"
 },
 "380": {
    "detail": "La Rioja"
 },
 "381": {
    "detail": "Tucumán"
 },
 "383": {
    "detail": "Catamarca"
 },
 "385": {
    "detail": "Santiago del Estero"
 },
 "387": {
    "detail": "Salta"
 },
 "388": {
    "detail": "Jujuy"
 },
 "2202": {
    "detail": "Buenos Aires"
 },
 "2221": {
    "detail": "Buenos Aires"
 },
 "2223": {
    "detail": "Buenos Aires"
 },
 "2224": {
    "detail": "Buenos Aires"
 },
 "2225": {
    "detail": "Buenos Aires"
 },
 "2226": {
    "detail": "Buenos Aires"
 },
 "2227": {
    "detail": "Buenos Aires"
 },
 "2229": {
    "detail": "Buenos Aires"
 },
 "2241": {
    "detail": "Buenos Aires"
 },
 "2242": {
    "detail": "Buenos Aires"
 },
 "2243": {
    "detail": "Buenos Aires"
 },
 "2244": {
    "detail": "Buenos Aires"
 },
 "2245": {
    "detail": "Buenos Aires"
 },
 "2246": {
    "detail": "Buenos Aires"
 },
 "2252": {
    "detail": "Buenos Aires"
 },
 "2254": {
    "detail": "Buenos Aires"
 },
 "2255": {
    "detail": "Buenos Aires"
 },
 "2257": {
    "detail": "Buenos Aires"
 },
 "2261": {
    "detail": "Buenos Aires"
 },
 "2262": {
    "detail": "Buenos Aires"
 },
 "2264": {
    "detail": "Buenos Aires"
 },
 "2265": {
    "detail": "Buenos Aires"
 },
 "2266": {
    "detail": "Buenos Aires"
 },
 "2267": {
    "detail": "Buenos Aires"
 },
 "2268": {
    "detail": "Buenos Aires"
 },
 "2271": {
    "detail": "Buenos Aires"
 },
 "2272": {
    "detail": "Buenos Aires"
 },
 "2273": {
    "detail": "Buenos Aires"
 },
 "2274": {
    "detail": "Buenos Aires"
 },
 "2281": {
    "detail": "Buenos Aires"
 },
 "2283": {
    "detail": "Buenos Aires"
 },
 "2284": {
    "detail": "Buenos Aires"
 },
 "2285": {
    "detail": "Buenos Aires"
 },
 "2286": {
    "detail": "Buenos Aires"
 },
 "2291": {
    "detail": "Buenos Aires"
 },
 "2292": {
    "detail": "Buenos Aires"
 },
 "2296": {
    "detail": "Buenos Aires"
 },
 "2297": {
    "detail": "Buenos Aires"
 },
 "2302": {
    "detail": "La Pampa /\nBuenos Aires"
 },
 "2314": {
    "detail": "Buenos Aires"
 },
 "2316": {
    "detail": "Buenos Aires"
 },
 "2317": {
    "detail": "Buenos Aires"
 },
 "2320": {
    "detail": "Buenos Aires"
 },
 "2323": {
    "detail": "Buenos Aires"
 },
 "2324": {
    "detail": "Buenos Aires"
 },
 "2325": {
    "detail": "Buenos Aires"
 },
 "2326": {
    "detail": "Buenos Aires"
 },
 "2331": {
    "detail": "La Pampa"
 },
 "2333": {
    "detail": "La Pampa"
 },
 "2334": {
    "detail": "La Pampa"
 },
 "2335": {
    "detail": "La Pampa"
 },
 "2336": {
    "detail": "Córdoba"
 },
 "2337": {
    "detail": "Buenos Aires"
 },
 "2338": {
    "detail": "La Pampa"
 },
 "2342": {
    "detail": "Buenos Aires"
 },
 "2343": {
    "detail": "Buenos Aires"
 },
 "2344": {
    "detail": "Buenos Aires"
 },
 "2345": {
    "detail": "Buenos Aires"
 },
 "2346": {
    "detail": "Buenos Aires"
 },
 "2352": {
    "detail": "Buenos Aires"
 },
 "2353": {
    "detail": "Buenos Aires/ \nSanta Fe"
 },
 "2354": {
    "detail": "Buenos Aires"
 },
 "2355": {
    "detail": "Buenos Aires"
 },
 "2356": {
    "detail": "Buenos Aires"
 },
 "2357": {
    "detail": "Buenos Aires"
 },
 "2358": {
    "detail": "Buenos Aires"
 },
 "2392": {
    "detail": "Buenos Aires"
 },
 "2393": {
    "detail": "Buenos Aires"
 },
 "2394": {
    "detail": "Buenos Aires"
 },
 "2395": {
    "detail": "Buenos Aires"
 },
 "2396": {
    "detail": "Buenos Aires"
 },
 "2473": {
    "detail": "Buenos Aires/ \nSanta Fe"
 },
 "2474": {
    "detail": "Buenos Aires"
 },
 "2475": {
    "detail": "Buenos Aires"
 },
 "2477": {
    "detail": "Buenos Aires/ \nSanta Fe"
 },
 "2478": {
    "detail": "Buenos Aires"
 },
 "2622": {
    "detail": "Mendoza"
 },
 "2624": {
    "detail": "Mendoza"
 },
 "2625": {
    "detail": "Mendoza"
 },
 "2626": {
    "detail": "Mendoza"
 },
 "2646": {
    "detail": "San Juan"
 },
 "2647": {
    "detail": "San Juan"
 },
 "2648": {
    "detail": "San Juan"
 },
 "2651": {
    "detail": "San Luis"
 },
 "2652": {
    "detail": "San Luis"
 },
 "2655": {
    "detail": "San Luis"
 },
 "2656": {
    "detail": "San Luis"
 },
 "2657": {
    "detail": "San Luis"
 },
 "2658": {
    "detail": "San Luis"
 },
 "2901": {
    "detail": "Tierra del Fuego"
 },
 "2902": {
    "detail": "Santa Cruz"
 },
 "2903": {
    "detail": "Chubut"
 },
 "2920": {
    "detail": "Río Negro/\nBuenos Aires"
 },
 "2921": {
    "detail": "Buenos Aires"
 },
 "2922": {
    "detail": "Buenos Aires"
 },
 "2923": {
    "detail": "Buenos Aires"
 },
 "2924": {
    "detail": "Buenos Aires \nLa Pampa"
 },
 "2925": {
    "detail": "Buenos Aires/\nLa Pampa"
 },
 "2926": {
    "detail": "Buenos Aires"
 },
 "2927": {
    "detail": "Buenos Aires"
 },
 "2928": {
    "detail": "Buenos Aires"
 },
 "2929": {
    "detail": "Buenos Aires"
 },
 "2931": {
    "detail": "Río Negro/\nLa Pampa"
 },
 "2932": {
    "detail": "Buenos Aires"
 },
 "2933": {
    "detail": "Buenos Aires"
 },
 "2934": {
    "detail": "Río Negro"
 },
 "2935": {
    "detail": "Buenos Aires"
 },
 "2936": {
    "detail": "Buenos Aires"
 },
 "2940": {
    "detail": "Río Negro"
 },
 "2942": {
    "detail": "Neuquén /\nRío Negro"
 },
 "2945": {
    "detail": "Chubut"
 },
 "2946": {
    "detail": "Río Negro"
 },
 "2948": {
    "detail": "Neuquén"
 },
 "2952": {
    "detail": "La Pampa"
 },
 "2953": {
    "detail": "La Pampa"
 },
 "2954": {
    "detail": "La Pampa"
 },
 "2962": {
    "detail": "Santa Cruz"
 },
 "2963": {
    "detail": "Santa Cruz"
 },
 "2964": {
    "detail": "Tierra del Fuego"
 },
 "2966": {
    "detail": "Santa Cruz"
 },
 "2972": {
    "detail": "Neuquén"
 },
 "2982": {
    "detail": "Buenos Aires"
 },
 "2983": {
    "detail": "Buenos Aires"
 },
 "3327": {
    "detail": "Buenos Aires"
 },
 "3329": {
    "detail": "Buenos Aires"
 },
 "3382": {
    "detail": "Santa Fe /\nBuenos Aires/\nCórdoba"
 },
 "3385": {
    "detail": "Córdoba"
 },
 "3387": {
    "detail": "Córdoba"
 },
 "3388": {
    "detail": "Buenos Aires"
 },
 "3400": {
    "detail": "Santa Fe"
 },
 "3401": {
    "detail": "Santa Fe"
 },
 "3402": {
    "detail": "Santa Fe"
 },
 "3404": {
    "detail": "Santa Fe"
 },
 "3405": {
    "detail": "Santa Fe"
 },
 "3406": {
    "detail": "Santa Fe"
 },
 "3407": {
    "detail": "Buenos Aires"
 },
 "3408": {
    "detail": "Santa Fe"
 },
 "3409": {
    "detail": "Santa Fe"
 },
 "3435": {
    "detail": "Entre Ríos"
 },
 "3436": {
    "detail": "Entre Ríos"
 },
 "3437": {
    "detail": "Entre Ríos"
 },
 "3438": {
    "detail": "Entre Ríos"
 },
 "3442": {
    "detail": "Entre Ríos"
 },
 "3444": {
    "detail": "Entre Ríos"
 },
 "3445": {
    "detail": "Entre Ríos"
 },
 "3446": {
    "detail": "Entre Ríos"
 },
 "3447": {
    "detail": "Entre Ríos"
 },
 "3454": {
    "detail": "Entre Ríos"
 },
 "3455": {
    "detail": "Entre Ríos"
 },
 "3456": {
    "detail": "Entre Ríos"
 },
 "3458": {
    "detail": "Entre Ríos"
 },
 "3460": {
    "detail": "Santa Fe"
 },
 "3462": {
    "detail": "Santa Fe"
 },
 "3463": {
    "detail": "Córdoba"
 },
 "3464": {
    "detail": "Santa Fe"
 },
 "3465": {
    "detail": "Santa Fe"
 },
 "3466": {
    "detail": "Santa Fe"
 },
 "3467": {
    "detail": "Córdoba/\nSanta Fe"
 },
 "3468": {
    "detail": "Córdoba/\nSanta Fe"
 },
 "3469": {
    "detail": "Santa Fe"
 },
 "3471": {
    "detail": "Santa Fe"
 },
 "3472": {
    "detail": "Córdoba"
 },
 "3476": {
    "detail": "Santa Fe"
 },
 "3482": {
    "detail": "Santa Fe"
 },
 "3483": {
    "detail": "Santa Fe"
 },
 "3487": {
    "detail": "Buenos Aires"
 },
 "3489": {
    "detail": "Buenos Aires"
 },
 "3491": {
    "detail": "Santa Fe/\nSantiago del Estero"
 },
 "3492": {
    "detail": "Santa Fe"
 },
 "3493": {
    "detail": "Santa Fe"
 },
 "3496": {
    "detail": "Santa Fe"
 },
 "3497": {
    "detail": "Santa Fe"
 },
 "3498": {
    "detail": "Santa Fe"
 },
 "3521": {
    "detail": "Córdoba"
 },
 "3522": {
    "detail": "Córdoba"
 },
 "3524": {
    "detail": "Córdoba"
 },
 "3525": {
    "detail": "Córdoba"
 },
 "3532": {
    "detail": "Córdoba"
 },
 "3533": {
    "detail": "Córdoba"
 },
 "3537": {
    "detail": "Córdoba"
 },
 "3541": {
    "detail": "Córdoba"
 },
 "3542": {
    "detail": "Córdoba"
 },
 "3543": {
    "detail": "Córdoba"
 },
 "3544": {
    "detail": "Córdoba"
 },
 "3546": {
    "detail": "Córdoba"
 },
 "3547": {
    "detail": "Córdoba"
 },
 "3548": {
    "detail": "Córdoba"
 },
 "3549": {
    "detail": "Córdoba"
 },
 "3562": {
    "detail": "Córdoba/\nSanta Fe"
 },
 "3563": {
    "detail": "Córdoba"
 },
 "3564": {
    "detail": "Córdoba/\nSanta Fe"
 },
 "3571": {
    "detail": "Córdoba"
 },
 "3572": {
    "detail": "Córdoba"
 },
 "3573": {
    "detail": "Córdoba"
 },
 "3574": {
    "detail": "Córdoba"
 },
 "3575": {
    "detail": "Córdoba"
 },
 "3576": {
    "detail": "Córdoba"
 },
 "3582": {
    "detail": "Córdoba/\nSan Luis"
 },
 "3583": {
    "detail": "Córdoba"
 },
 "3584": {
    "detail": "Córdoba"
 },
 "3585": {
    "detail": "Córdoba"
 },
 "3711": {
    "detail": "Formosa"
 },
 "3715": {
    "detail": "Formosa/\nChaco"
 },
 "3716": {
    "detail": "Formosa"
 },
 "3718": {
    "detail": "Formosa"
 },
 "3721": {
    "detail": "Chaco"
 },
 "3725": {
    "detail": "Chaco"
 },
 "3731": {
    "detail": "Chaco"
 },
 "3734": {
    "detail": "Chaco"
 },
 "3735": {
    "detail": "Chaco"
 },
 "3741": {
    "detail": "Misiones"
 },
 "3743": {
    "detail": "Misiones"
 },
 "3751": {
    "detail": "Misiones"
 },
 "3754": {
    "detail": "Misiones"
 },
 "3755": {
    "detail": "Misiones"
 },
 "3756": {
    "detail": "Corrientes"
 },
 "3757": {
    "detail": "Misiones"
 },
 "3758": {
    "detail": "Misiones /\nCorrientes"
 },
 "3772": {
    "detail": "Corrientes"
 },
 "3773": {
    "detail": "Corrientes"
 },
 "3774": {
    "detail": "Corrientes"
 },
 "3775": {
    "detail": "Corrientes"
 },
 "3777": {
    "detail": "Corrientes"
 },
 "3781": {
    "detail": "Corrientes"
 },
 "3782": {
    "detail": "Corrientes"
 },
 "3786": {
    "detail": "Corrientes"
 },
 "3821": {
    "detail": "La Rioja"
 },
 "3825": {
    "detail": "La Rioja"
 },
 "3826": {
    "detail": "La Rioja"
 },
 "3827": {
    "detail": "La Rioja"
 },
 "3832": {
    "detail": "Catamarca/\nSantiago del Estero"
 },
 "3835": {
    "detail": "Catamarca"
 },
 "3837": {
    "detail": "Catamarca"
 },
 "3838": {
    "detail": "Catamarca"
 },
 "3841": {
    "detail": "Santiago del Estero"
 },
 "3843": {
    "detail": "Santiago del Estero"
 },
 "3844": {
    "detail": "Santiago del Estero"
 },
 "3845": {
    "detail": "Santiago del Estero"
 },
 "3846": {
    "detail": "Santiago del Estero"
 },
 "3854": {
    "detail": "Santiago del Estero"
 },
 "3855": {
    "detail": "Santiago del Estero"
 },
 "3856": {
    "detail": "Santiago del Estero"
 },
 "3857": {
    "detail": "Santiago del Estero"
 },
 "3858": {
    "detail": "Santiago del Estero"
 },
 "3861": {
    "detail": "Santiago del Estero"
 },
 "3862": {
    "detail": "Tucumán"
 },
 "3863": {
    "detail": "Tucumán"
 },
 "3865": {
    "detail": "Tucumán"
 },
 "3867": {
    "detail": "Tucumán"
 },
 "3868": {
    "detail": "Salta"
 },
 "3869": {
    "detail": "Tucumán"
 },
 "3873": {
    "detail": "Salta"
 },
 "3876": {
    "detail": "Salta"
 },
 "3877": {
    "detail": "Salta/\nChaco"
 },
 "3878": {
    "detail": "Salta"
 },
 "3885": {
    "detail": "Jujuy /\nSalta"
 },
 "3886": {
    "detail": "Jujuy"
 },
 "3887": {
    "detail": "Jujuy"
 },
 "3888": {
    "detail": "Jujuy"
 },
 "3891": {
    "detail": "Tucumán"
 },
 "3892": {
    "detail": "Tucumán"
 },
 "3894": {
    "detail": "Tucumán"
 }
}
}; }
 }
